<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="学员名称">
        <Input
          v-model="searchCondition.name"
          placeholder="学员名称"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="手机号码">
        <Input
          v-model="searchCondition.mobile"
          placeholder="手机号码"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/checkin-joiners"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        keyField="id"
        method="get"
      >
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionJoiner",
  data() {
    return {
      searchCondition: {
        name: "",
        mobile: "",
        id: this.$route.query.id,
        init: function() {
          this.name = "";
          this.mobile= "";
          this.id= this.$route.query.id;
        }
      },
      tableColumns: [
        { title: "学员名称", key: "nickname", align: "center", minWidth: 180 },
        {
          title: "手机号码",
          key: "mobile",
          align: "center",
          minWidth: 100
        },
        { title: "应打卡天数", key: "checkin_days", align: "center", minWidth: 100 },
        { title: "实际打卡天数", key: "total_days", align: "center", minWidth: 200 },
        { title: "连续打卡天数", key: "continuous_days", align: "center", minWidth: 100 }
      ]
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.nickname = item.user.nickname;
        item.mobile = item.user.mobile;
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
      }
      this.$refs.grid.searchRefresh();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
